import { Top, FeaturesTech } from "./index.js";

export function Tech_Specs() {
	return `
    ${Top()}                                                                                      
    ${FeaturesTech()}    
  `;
}